import { GlobalDisclaimerLevel } from '@kurtosys/ksys-app-template/dist/models/disclaimers';
import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			breakpoints: [
				{
					size: 'medium',
					modifier: 'up',
					props: {
						show: {
							chart: true,
							table: true,
						},
					},
				},
			],
		},
		card: {
			props: {},
			queries: {
				title: {
					queryOptionsType: 'none',
					value: 'Discrete Performance (12m rolling)',
				},
			},
		},
		asOfDate: {
			text: 'As at {date}',
			date: {
				queryOptionsType: 'statistics',
				entityType: 'CLSS',
				code: 'performance_annual_returns',
				key: 'effective_date',
				index: 0,
				placeholder: '-',
			},
		},
		barChart: {
			chartProps: {
				composedChartProps: {
					barGap: 8,
				},
				commonSeriesProps: {
					barSize: 42,
					// labelList: {
					// 	position: 'top',
					// 	offset: 5,
					// },
				},
				colors: ['#005587', '#D9DCE1', '#36B37E'],
				elementOverrides: {
					cartesianGrid: {
						hide: true,
					},
					legend: {
						iconType: 'circle',
					},
					tooltip: {
						cursor: false,
						formatter: {
							type: 'percent',
							options: {
								maximumFractionDigits: 2,
								minimumFractionDigits: 2,
							},
							transforms: [
								{
									operator: 'divide',
									value: 100,
								},
							],
						},
					},
					xAxis: {
						dataKey: 'label',
						domain: ['dataMin', 'dataMax'],
						tickFormatter: {
							type: 'date',
							options: {
								year: 'numeric',
							},
						},
					},
				},
				dateOptions: {
					xAxisDateAsNumber: true,
				},
				additionalElements: [
					{
						type: 'ReferenceLine',
						props: {
							y: 0,
							stroke: '#D9DDE1',
						},
					},
				],
				breakpoints: [
					{
						size: 'small',
						modifier: 'down',
						props: {
							composedChartProps: {
								layout: 'vertical',
							},
							commonSeriesProps: {
								barSize: 45,
								labelList: {
									position: 'outside',
									offset: 5,
									formatter: {
										type: 'percent',
										options: {
											maximumFractionDigits: 2,
											minimumFractionDigits: 2,
										},
										transforms: [
											{
												operator: 'divide',
												value: 100,
											},
										],
									},
								},
							},
							elementOverrides: {
								xAxis: {
									type: 'number',
									stroke: '#D9DDE1',
									label: {
										value: 'Percentage %',
										dy: 10,
									},
									tickPivotPoint: 0,
								},
								yAxis: {
									dataKey: 'name',
									type: 'category',
									customTickLabel: {
										width: 100,
										textAnchor: 'end',
									},
									axisLine: false,
									tickLine: false,
								},
							},
							additionalElements: [
								{
									type: 'ReferenceLine',
									props: {
										x: 0,
										stroke: '#D9DDE1',
										strokeWidth: 2,
									},
								},
							],
						},
					},
					{
						size: 'medium',
						modifier: 'up',
						props: {
							dateOptions: {
								xAxisDateAsNumber: true,
							},
							elementOverrides: {
								yAxis: {
									stroke: '#D9DDE1',
									label: {
										value: 'Percentage %',
										angle: -90,
										dx: -20,
									},
									tickPivotPoint: 0,
								},
							},
							additionalElements: [
								{
									type: 'ReferenceLine',
									props: {
										y: 5,
										stroke: 'hotpink',
									},
									queries: {
										y: {
											queryOptionsType: 'none',
											value: 10,
										},
									},
								},
							],
						},
					},
				],
				seriesProps: [
					{
						dataKey: 'value',
						fill: '#d36d01',
						disclaimers: [
							{
								disclaimers: [
									{
										disclaimerType: 'Test',
										textQuery: {
											queryOptionsType: 'none',
											value: 'This is a test disclaimer for Kurtosys Bond A EUR Acc',
										},
										level: GlobalDisclaimerLevel.app,
									},
								],
							},
						],
					},
					{
						dataKey: 'benchmark',
						fill: '#BEBDBE',
					},
				],
			},
			data: {
				queryOptionsType: 'statistics',
				entityType: 'CLSS',
				code: 'performance_annual_returns',
				checkPerformanceAllowed: false,
				placeholder: '-',
			},
			seriesPropsOverrides: [
				{
					dataKey: 'value',
					name: {
						queryOptionsType: 'property',
						entityType: 'CLSS',
						code: 'public_share_class_name',
						key: 'value',
					},
				},
				{
					dataKey: 'benchmark',
					name: {
						queryOptionsType: 'property',
						entityType: 'CLSS',
						code: 'benchmark',
						key: 'value',
					},
				},
			],
			disclaimers: [
				{
					queryOptionsType: 'disclaimers',
					key: 'perf_chart_explanatory_text',
				},
				{
					queryOptionsType: 'disclaimers',
					key: 'performance_disclaimer',
				},
			],
			averageLine: {
				axisDataKey: 'label',
				averageValueQuery: {
					queryOptionsType: 'statistics',
					entityType: 'CLSS',
					code: 'performance_annual_returns',
					index: 0,
					key: 'average',
				},
				type: 'Line',
				props: {
					dataKey: 'average',
					dot: false,
					legendType: 'plainline',
					name: 'average',
					stroke: 'black',
					strokeWidth: 2,
					strokeDasharray: '5',
					isAnimationActive: false,
				},
			},
		},
	},
};
